var OpenpayButton = (function (BaseView) {

    var OpenpayButton = BaseView.extend({

        tagName: 'div',

        className: 'pay-button__openpay',

        hiddenClass: 'hidden-block',

        initialize: function (opts) {
            this._buttonFac = opts && opts.buttonFac;
            this.listenTo(this.model, "change", _.bind(this._render, this));
            this._btn = null;
        },

        _render: function () {
            if (this._btn) {
                this._btn.remove();
            }

            var isAvailable = this.model.get('IsAvailable');

            // NOTE: case when no available and no description (disabled button), should be not available button
            if (!isAvailable) {
                this._btn = null;
                this.$el.addClass(this.hiddenClass);
                return this;
            }

            // TODO: it's not good to use buttonFac view to render description, 
            // TODO: but due to complex and not backbone friendly templates it's the easiest way to do this.
            // TODO: also it's "low amount of edits in the code" fix. 
            this._btn = this._buttonFac(this.$el, {
                isAvailable: isAvailable
            });

            this.$el.removeClass(this.hiddenClass);

            return this;
        },

        renderTo: function (container) {
            this._render().$el.appendTo($(container));

            return this;
        },

        remove: function() {
            if (this._btn) this._btn.remove();
            OpenpayButton.prototype.remove.call(this);
        }
    });

    return OpenpayButton;
})(BaseView);